export default __webpack_public_path__ + "b0f81e67bcb330cd69c204f73ce2424f.png";